import React from 'react';
import MaterialTableCell, {
    TableCellProps as MaterialTableCellProps,
} from '@mui/material/TableCell';
import styled from 'styled-components';

const StyledTableCell = styled(MaterialTableCell)`
    font-family: sans-serif !important;
`;

export interface TableCellProps extends MaterialTableCellProps {}

const TableCell: React.FunctionComponent<TableCellProps> = ({ children, ...props }) => {
    return <StyledTableCell {...props}>{children}</StyledTableCell>;
};

export default TableCell;
